export default __webpack_public_path__ + "static/media/cassandra.cb1e869e.svg";